import { useState } from "react";
import useReadWithGet from "../../hooks/read/useReadWithGetMethod";
import usePut from "../../hooks/put/usePut";
import { ArrowLeftIcon } from "@heroicons/react/solid";
import Calendar from "../../components/Dates/Calendar";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Alert, Modal, Snackbar } from "@mui/material";
import spinner from "../../assets/images/spinner.gif";
import { useQueryClient } from "@tanstack/react-query";
import Moment from "react-moment";
import { numberWithComma } from "../../utility";
import useDownloadFile from "../../hooks/useDownloadFile";
import Loader from "../../components/Loader";
import PaymentLog from "./PaymentLog";
import BreadCrumbs from "../../components/ui/BreadCrumbs";
import { Button } from "../../components/ui";
import RoundedContainer from "../../components/containers/RoundedContainer";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from "../../components/table/Table";

const tempData = {
  employee_name: "",
  salary: "",
  gst: "",
  professional_tax: "",
  approved_leaves: "",
  tds: "",
  base_salary: "",
  total_days_present: "",
  total_days_absent: "",
  department: "",
  designation: "",
  absent_deduction: "",
  total_pending_dates: "",
  days_present: "",
  days_absent: "",
  public_holidays: "",
  approved_leaves_dates: "",
  month_days: "",
  pending_dates: "",
  prev_month_sal_deduction: "",
  previous_month_absent: "",
  previous_month_days: "",
  not_joined_or_left: [],
};

const getDateMonthString = (date) => {
  let tempDate = new Date(date);
  let month = tempDate.getMonth() + 1;
  return tempDate.getFullYear() + "-" + month;
};

const SalaryLogs = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();
  const breadcrumbs = [
    { label: "Salary", link: "/salary" },
    { label: "Salary Logs", link: "" },
  ];
  const [editable, setEditable] = useState(false);
  // let generated = searchParams.get("status") === "generated" ? true : false
  let employee = searchParams.get("emp") === "Employee`" ? true : false;
  const [currentDatesSection, setCurrentDatesSection] = useState("");
  const [listData, setListData] = useState(tempData);
  const [initialListData, setInitialListData] = useState(null);
  const [filterData, setFilterData] = useState({
    month_and_year: new Date(searchParams.get("date")),
    prev_month_and_year: new Date(searchParams.get("prev_date")),
  });
  // popup messages
  const [createSuccessMessage, setCreateSuccessMessage] = useState(false);
  const [updateSuccessMessage, setUpdateSuccessMessage] = useState(false);

  const { list } = useReadWithGet({
    url: "getPayoutList",
    initialData: {
      month_year: getDateMonthString(searchParams.get("date")),
      company_employee_id: searchParams.get("company_employee_id"),
    },
    onSuccess: (data) => {
      setInitialListData(data?.data[0]);
      setListData(data?.data);
    },
  });

  const handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setListData({
      ...listData,
      [name]: value,
    });
  };

  const [showDates, setShowDates] = useState(false);

  const handleViewDates = (datesSection) => {
    setShowDates(true);
    setCurrentDatesSection(datesSection);
  };
  const handlePrevViewDates = (datesSection) => {
    setShowDates(true);
    setCurrentDatesSection(datesSection);
  };


  const storeTdsInPayout = usePut({
    url: "storeTdsInPayout",
    onSuccess: (data) => { },
  });

  const handleSaveExtras = () => {
    let data = {
      payout_id: listData["payout_id"],
      tds: listData["tds"] || "",
      other_deduction: listData["others_charges"] || "",
      consultation_fees: listData["consultation_fees"] || "",
    };
    storeTdsInPayout.handleAuth.mutate(data);
  };
  const { reportDownload } = useDownloadFile({
    url: "salary_slip",
    filename: "salary_slip.pdf",
  });

  const handleDownloadSalarySlip = () => {
    let data = {
      month_year: filterData.month_and_year,
      company_employee_id: searchParams.get("company_employee_id"),
    };
    reportDownload.mutate(data);
  };

  const [paymentLogModal, setPaymentLogModal] = useState(false);
  const handleOpenPaymentLogs = () => {
    setPaymentLogModal(true);
  };
  return (
    <>
      <div className="mx-6 py-4 flex justify-between">
        <BreadCrumbs crumbs={breadcrumbs} />
        <div>
          <Button
            onClick={handleOpenPaymentLogs}
            variant={"ghost"}
            className="text-gray-600 rounded font-semibold"
          >
            View payment logs
          </Button>
          <Button
            onClick={handleDownloadSalarySlip}
            variant={"ghost"}
            className=" text-blue-500 font-semibold hover:underline"
          >
            Download Salary Slip
          </Button>
        </div>
        {listData["status"] === "generated" && !editable && (
          <Button
            onClick={() => setEditable(!editable)}
            type="button"
            className=""
          >
            Edit
          </Button>
        )}
      </div>
      <small className=" text-red-500 font-semibold px-6 mb-2 inline-block">
        All the changes will be added once you save
      </small>
      {list?.isLoading || reportDownload.isLoading ? (
        <div className=" w-16 h-16 mx-auto mt-8">
          <img src={spinner} alt="spinner" className="w-full h-full" />
        </div>
      ) : (
        <div className="mx-6 mb-10">
          <div>
            {listData?.salary_payout?.processing_status === "1" ? (
              <snap className=" px-4 py-2 bg-green-100 text-green-600 rounded-md font-semibold">
                Payroll Processed
              </snap>
            ) : listData?.salary_payout?.processing_status === "2" ? (
              <snap className=" px-4 py-2 bg-yellow-100 text-yellow-600 rounded-md font-semibold">
                Payroll Under Process
              </snap>
            ) : listData?.salary_payout?.processing_status === "3" ? (
              <snap className=" px-4 py-2 bg-yellow-100 text-yellow-600 rounded-md font-semibold">
                Payroll Pending
              </snap>
            ) : listData?.salary_payout?.processing_status === "4" ? (
              <snap className=" px-4 py-2 bg-yellow-100 text-yellow-600 rounded-md font-semibold">
                Draft in process
              </snap>
            ) : listData?.salary_payout?.processing_status === "5" ? (
              <snap className=" px-4 py-2 bg-yellow-100 text-yellow-600 rounded-md font-semibold">
                Viewing In Draft Mode
              </snap>
            ) : (
              <snap className=" px-4 py-2 bg-blue-100 text-blue-600 rounded-md font-semibold">
                Viewing In Draft Mode
              </snap>
            )}
          </div>
          <div className="document-body py-4 px-1 -mx-1 overflow-auto">
            <RoundedContainer className={"w-fit"}>
              <Table className="min-w-[35rem] w-[40%]">
                <TableHead>
                  <TableHeaderCell
                    colSpan="2"
                    className="font-bold text-center"
                  >
                    Employee Details
                  </TableHeaderCell>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell className="font-bold">Employee Name</TableCell>
                    <TableCell className="">
                      {listData?.employee_name}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="font-bold">Designation</TableCell>
                    <TableCell className="">{listData?.designation}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="font-bold">Department</TableCell>
                    <TableCell className="">{listData?.department}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="font-bold">Date of Joining</TableCell>
                    <TableCell className="">
                      <Moment unix format="LL">
                        {listData?.date_of_joining_unix}
                      </Moment>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </RoundedContainer>

            <RoundedContainer>
              <Table className="w-full">
                <TableHead>
                  <TableHeaderCell className="font-bold">
                    {/* <Button className='text-center bg-gray-200 text-gray-700 roboto font-semibold text-sm hover:bg-gray-300 mr-6' onClick={() => handlePrevViewDates('previous')}>
                      Prev. Month
                    </Button> */}
                  </TableHeaderCell>
                  <TableHeaderCell
                    colSpan="4"
                    className="font-bold text-center"
                  >
                    Attendance Details
                  </TableHeaderCell>
                  <TableHeaderCell className="font-bold ">
                    <Button
                      className="text-center text-gray-200 bg-gray-700 font-semibold text-sm hover:bg-gray-800 ml-6"
                      onClick={() => handleViewDates("present")}
                    >
                      Curr. Month
                    </Button>
                  </TableHeaderCell>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell className="font-bold text-center">
                      Worked Days
                    </TableCell>
                    <TableCell className="font-bold text-center">
                      Paid Leaves
                    </TableCell>
                    <TableCell className="font-bold text-center">
                      Half Days
                    </TableCell>
                    <TableCell className="font-bold text-center">
                      Absent Days
                    </TableCell>
                    <TableCell className="font-bold text-center">
                      {listData["shift_type"] === "strict"
                        ? "Late Days"
                        : "Total Hours Worked"}
                    </TableCell>
                    <TableCell className="font-bold text-center">
                      Week Offs
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="text-center">
                      {listData["total_days_present"]}
                    </TableCell>
                    <TableCell className="text-center">
                      {listData["approved_leaves"]}
                    </TableCell>
                    <TableCell className="text-center">
                      {listData["total_half_days"]}
                    </TableCell>
                    <TableCell className="text-center">
                      {listData["total_days_absent"]}
                    </TableCell>
                    <TableCell className="text-center">
                      {listData["shift_type"] === "strict"
                        ? listData["total_late_dates"]
                        : listData["total_worked_hours"]}
                    </TableCell>
                    <TableCell className="text-center">
                      {listData["total_week_off"]}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </RoundedContainer>

            <div className="grid grid-cols-2 gap-5 mt-8">
              <RoundedContainer>
                <Table className="w-full h-full">
                  <TableHead>
                    <TableHeaderCell className="font-bold">
                      Earnings
                    </TableHeaderCell>
                    <TableHeaderCell className="font-bold">
                      Amount
                    </TableHeaderCell>
                  </TableHead>
                  <TableBody>
                    {/* <tr>
                    <td className="font-bold">
                      {listData?.type_of_employee === "EMPLOYEE"
                        ? "Salary"
                        : "Consultation Fee"}
                    </td>
                    <td className="">
                      ₹ {listData?.base_salary}
                    </td>
                  </tr> */}
                    {/* <tr className="">
                    <td className="font-bold">
                      Consultation Fee (Extras)
                    </td>
                    <td className="">
                      <input
                        onChange={handleChange}
                        value={listData?.consultation_fees}
                        name="consultation_fees"
                        placeholder="Enter Amount"
                        className="w-full focus:outline-none ml-1 input"
                        type="number"
                      />
                    </td>
                  </tr> */}

                    {listData?.earnings_components?.map((cmp, index) => {
                      const { component_name, value } = cmp;
                      return (
                        <TableRow className="">
                          <TableCell className="font-bold">
                            {component_name}
                          </TableCell>
                          <TableCell className="">&#8377; {value}</TableCell>
                        </TableRow>
                      );
                    })}
                    <TableRow className="">
                      <TableCell className="font-bold border-t-2 border-t-gray-400">
                        Total Earnings
                      </TableCell>
                      <TableCell className="font-bold border-t-2 border-t-gray-400">
                        &#8377;{" "}
                        {/* {+listData?.base_salary +
                        (listData?.consultation_fees
                          ? +listData?.consultation_fees
                          : 0)} */}
                        {listData?.gross_salary}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </RoundedContainer>

              <RoundedContainer>
                <Table className="w-full h-full">
                  <TableHead>
                    <TableHeaderCell className="font-bold">
                      Deduction
                    </TableHeaderCell>
                    <TableHeaderCell className="font-bold">
                      Amount
                    </TableHeaderCell>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell className="font-bold ">
                        Absent Deduction
                      </TableCell>
                      <TableCell className="">
                        ₹ {listData?.absent_deduction}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="font-bold ">
                        Prev. Month Deduction
                      </TableCell>
                      <TableCell className="">
                        ₹ {listData?.prev_month_sal_deduction}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="font-bold ">
                        <span className="block">TDS</span>
                        {/* {listData?.type_of_employee !== "employee" && (
                          <small className=" text-[9px] text-gray-400">
                            (FLAT 10% TDS)
                          </small>
                        )} */}
                      </TableCell>
                      <TableCell className="">
                        {listData?.type_of_employee === "EMPLOYEE" ? (
                          <input
                            type="number"
                            className="input"
                            name="tds"
                            value={listData.tds || ""}
                            onChange={handleChange}
                            placeholder="Enter TDS here.."
                          />
                        ) : (
                          `₹ ${listData.tds || 0}`
                        )}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="font-bold ">Others</TableCell>
                      <TableCell className="">
                        <input
                          type="number"
                          className="input"
                          value={listData.others_charges}
                          name="others_charges"
                          onChange={handleChange}
                          placeholder="Enter Amount.."
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="font-bold  border-t-gray-400 border-t-2">
                        Total Deductions
                      </TableCell>
                      <TableCell className="font-bold  border-t-gray-400 border-t-2">
                        ₹{" "}
                        {+listData?.prev_month_sal_deduction +
                          +listData?.absent_deduction +
                          (+listData?.tds || 0) +
                          (+listData?.others_charges || 0)}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </RoundedContainer>
            </div>
            <div className="grid grid-cols-2 mt-8">
              <RoundedContainer>
                <Table className="w-full">
                  <TableHead>
                    <TableHeaderCell className="font-bold">
                      Statutory
                    </TableHeaderCell>
                    <TableHeaderCell className="font-bold">
                      Statutory Amount
                    </TableHeaderCell>
                  </TableHead>
                  <TableBody>
                    {/* <TableRow>
                    <TableCell className="font-bold">
                      Professional Tax
                    </TableCell>
                    <TableCell className="">
                      ₹ {listData?.professional_tax || 0}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="font-bold border py-3 px-4">EPF</TableCell>
                    <TableCell className="">
                      ₹ {listData?.epf || 0}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="font-bold">ESIC</TableCell>
                    <TableCell className="">
                      ₹ {listData?.esic || 0}
                    </TableCell>
                  </TableRow> */}
                    {listData?.statutory_components?.map((cmp, index) => {
                      const { statutory_name, employee_value } = cmp;
                      return (
                        <TableRow key={index}>
                          <TableCell className="font-bold">
                            {statutory_name}
                          </TableCell>
                          <TableCell className="">
                            &#8377; {employee_value}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                    <TableRow>
                      <TableCell className="font-bold border-t-2 border-t-gray-400">
                        Total
                      </TableCell>
                      <TableCell className="border-t-gray-400 border-t-2 font-bold">
                        &#8377;{" "}
                        {/* {numberWithComma(
                        +listData?.professional_tax +
                          +listData?.epf +
                          +listData?.esic
                      )} */}
                        {listData?.statutory_components?.reduce(
                          (acc, cmp) => acc + (+cmp.employee_value || 0),
                          0
                        )}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </RoundedContainer>
            </div>
          </div>
          <small className=" text-red-500 font-semibold mb-2 inline-block">
            All the changes will be added once you save
          </small>
          <p className="my-3 mb-6 font-bold">
            Net Salary: ₹{" "}
            {
              // numberWithComma(
              //     Math.round(+listData?.base_salary -
              //         (listData?.prev_month_sal_deduction + +listData?.absent_deduction + (+listData?.tds || 0) + (+listData?.others_charges || 0)) - +listData?.professional_tax + +listData?.epf + +listData?.esic
              //     )
              // )
              numberWithComma(listData?.net_salary)
            }
          </p>
          {/* <Button onClick={handleSaveExtras} type='button' size="icon" className=''>Save Payroll 
            {storeTdsInPayout?.handleAuth?.isLoading && <div className='flex flex-row items-center  w-6 h-6 mx-auto ml-2'><img src={spinner} alt="spinner" className='w-full h-full' /></div>}
          </Button> */}

          <div>
            {listData?.salary_payout?.processing_status === "1" ? (
              <span className=" px-4 py-2 bg-green-100 text-green-600 rounded-md font-semibold">
                Payroll Processed
              </span>
            ) : listData?.salary_payout?.processing_status === "2" ? (
              <span className=" px-4 py-2 bg-yellow-100 text-yellow-600 rounded-md font-semibold">
                Payroll Under Process
              </span>
            ) : listData?.salary_payout?.processing_status === "3" ? (
              <span className=" px-4 py-2 bg-yellow-100 text-yellow-600 rounded-md font-semibold">
                Payroll Pending
              </span>
            ) : listData?.salary_payout?.processing_status === "4" ? (
              <span className=" px-4 py-2 bg-yellow-100 text-yellow-600 rounded-md font-semibold">
                Draft in process
              </span>
            ) : listData?.salary_payout?.processing_status === "5" ? (
              <Button onClick={handleSaveExtras} className="space-x-3">
                <span>Save TDS</span>
                {storeTdsInPayout.handleAuth.isLoading && <Loader />}
              </Button>
            ) : (
              <Button onClick={handleSaveExtras} className="space-x-3">
                <span>Save Payroll</span>
                {storeTdsInPayout.handleAuth.isLoading && <Loader />}
              </Button>
            )}
          </div>
        </div>
      )}
      {
        <Modal
          open={showDates}
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
        >
          <div className="document-wrapper px-6 divide-y bg-white h-max max-h-[80%] w-[40rem] ml-[30%] mt-[5%] overflow-auto">
            <>
              <div className="document-head py-4">
                <div className="flex items-center">
                  <div
                    className=" w-5 h-5 cursor-pointer mr-3"
                    onClick={() => setShowDates(false)}
                  >
                    <ArrowLeftIcon className=" text-black w-full h-full" />
                  </div>
                  <h3 className=" text-gray-700 text-2xl font-semibold">
                    Calendar
                  </h3>
                </div>
              </div>
              <div className=" pt-2 pb-4 overflow-auto">
                {currentDatesSection === "present" && (
                  <>
                    <div className="grid grid-cols-3 gap-y-2 gap-x-5 mb-4">
                      <div className="flex mt-4 flex-row mr-6 items-center">
                        <p className="px-2 py-2 rounded flex items-center justify-center bg-[color:var(--color1)] text-white text-center uppercase font-semibold text-sm"></p>
                        <p className="ml-2 text-sm">Present</p>
                      </div>
                      <div className="flex mt-4 flex-row mr-6 items-center">
                        <p className="px-2 py-2 bg-[color:var(--color13)] rounded flex items-center justify-center text-white text-center uppercase font-semibold text-sm"></p>
                        <p className="ml-2 text-sm">Absent</p>
                      </div>
                      <div className="flex mt-4 flex-row mr-6 items-center">
                        <p className="px-2 py-2 bg-orange-500 rounded flex items-center justify-center text-white text-center uppercase font-semibold text-sm"></p>
                        <p className="ml-2 text-sm">Public Holidays</p>
                      </div>
                      <div className="flex mt-4 flex-row mr-6 items-center">
                        <p className="px-2 py-2 bg-gray-400 rounded flex items-center justify-center text-white text-center uppercase font-semibold text-sm"></p>
                        <p className="ml-2 text-sm">Not Joined/Left</p>
                      </div>
                      <div className="flex mt-4 flex-row mr-6 items-center">
                        <p className="px-2 py-2 bg-[color:var(--color14)] rounded flex items-center justify-center text-white text-center uppercase font-semibold text-sm"></p>
                        <p className="ml-2 text-sm">Data pending</p>
                      </div>
                      <div className="flex mt-4 flex-row mr-6 items-center">
                        <p className="px-2 py-2 bg-lime-500 rounded flex items-center justify-center text-white text-center uppercase font-semibold text-sm"></p>
                        <p className="ml-2 text-sm">Half Days</p>
                      </div>
                      <div className="flex mt-4 flex-row mr-6 items-center">
                        <p className="px-2 py-2 bg-indigo-600 rounded flex items-center justify-center bg-[color:var(--color1)] text-white text-center uppercase font-semibold text-sm"></p>
                        <p className="ml-2 text-sm">Approved Leaves</p>
                      </div>
                    </div>
                    <Calendar
                      attendanceDates={{
                        days_present: listData["days_present"],
                        days_absent: listData["days_absent"],
                        approved_leaves_dates:
                          listData["approved_leaves_dates"],
                        pending_dates: listData["pending_dates"],
                        month_days: listData["month_days"],
                        public_holidays: listData["public_holidays"],
                        unpaidDays: listData["half_days"],
                        not_joined_or_left: listData["not_joined_or_left"],
                      }}
                      monthDateObject={filterData?.month_and_year}
                    />
                  </>
                )}
                {currentDatesSection === "previous" && (
                  <>
                    <div className="grid grid-cols-1 gap-2 pb-8">
                      <p className="px-4 py-2 rounded flex items-center justify-center bg-[color:var(--color13)] text-white text-center uppercase font-semibold text-sm">
                        Prev Month Deduction For Current Month
                      </p>
                    </div>
                    <Calendar
                      attendanceDates={{
                        days_present: Array(),
                        days_absent: listData["previous_month_absent"],
                        approved_leaves_dates: Array(),
                        pending_dates: Array(),
                        month_days: listData["previous_month_days"],
                        public_holidays: Array(),
                        unpaidDays: listData["half_days"],
                        not_joined_or_left: [],
                      }}
                      monthDateObject={filterData?.prev_month_and_year}
                    />
                  </>
                )}
              </div>
            </>
          </div>
        </Modal>
      }
      <Snackbar
        open={createSuccessMessage}
        autoHideDuration={6000}
        onClose={() => setCreateSuccessMessage(false)}
      >
        <Alert severity="success" sx={{ width: "100%" }}>
          Payment Created Successfully
        </Alert>
      </Snackbar>
      <Snackbar
        open={updateSuccessMessage}
        autoHideDuration={6000}
        onClose={() => setUpdateSuccessMessage(false)}
      >
        <Alert severity="success" sx={{ width: "100%" }}>
          Payment Updated Successfully
        </Alert>
      </Snackbar>

      <PaymentLog
        open={paymentLogModal}
        onClose={() => setPaymentLogModal(false)}
        id={searchParams.get("company_employee_id")}
      />
    </>
  );
};

export default SalaryLogs;
